export default __webpack_public_path__ + "static/media/chat-img.abcd6e88.png";